import { RootState } from '@/models/root-state.model';
import { IpDataModel } from '@/models/ip-data.model';
import { WrapperPlatform } from '@/models/enum/wrapper-platform.enum';
import { createSelector } from 'reselect';
import { isEmpty } from '@/shared/utility';
import { OntarioLocationCheckStatus } from '@/models/enum/ontario-location-check-status.enum';

export const selectLocale = (state: RootState): string => state.common.locale;
export const selectLoadZendesk = (state: RootState): boolean => state.common.loadZendesk;
export const selectMigrationLoading = (state: RootState): boolean => state.common.migrationLoading;
export const selectFitToPlay = (state: RootState): boolean => state.common.fitToPlay;
export const selectIpData = (state: RootState): IpDataModel => state.common.ipData;
export const selectOntarioCanPlay = (state: RootState): boolean => state.common.ontarioCanPlay;
export const selectBtag = (state: RootState): string => state.common.btag;
export const selectOntarioLocationCheckStatus = (state: RootState): OntarioLocationCheckStatus =>
  state.common.ontarioLocationCheckStatus;
export const selectBtagPrefix = createSelector(selectBtag, btag =>
  !isEmpty(btag) ? btag.split('_')[0] : undefined,
);

export const selectWrapperPlatform = (state: RootState): WrapperPlatform => state.common.platform;

export const selectIsInAppWrapper = createSelector(
  selectWrapperPlatform,
  platform => platform !== WrapperPlatform.None,
);

export const selectIsThailand = createSelector(selectLocale, locale => locale === 'th');
